import { TelephoneCountryCodesEnum } from '../../../resources/base/models';
import { boolToStrBool } from '../../../services/common/miscUtils';
import { CustomerData, MissingMilesData } from '../../../services/redux/features/customer.slice';
import { apiDateToUiDate } from '../utils/formatDate';

export const getPrivateCustomerFormInitialValues = (
  quoteData: QuoteSchema.Schemas.QuoteResponse,
  customerData: Partial<CustomerData>,
  missingMilesData?: MissingMilesData
) => {
  const offer = quoteData.financialProduct?.offers?.[0];
  const previousContractId = offer?.previousContractId;

  return {
    gender: customerData.gender,
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    birthName: customerData.birthName,
    dateOfBirth: apiDateToUiDate(customerData.dateOfBirth),
    profession: customerData.employment?.posFrOccupation ?? missingMilesData?.posFrOccupation,
    email: customerData.contactData?.emails?.[0]?.emailAddress?.toLowerCase(),
    telephonePhone: customerData.contactData?.telephoneNumber,
    mobilePhone: customerData.contactData?.mobilePhoneNumber,
    mobilePhoneCountryCode: customerData.contactData?.mobilePhoneCountryCode || TelephoneCountryCodesEnum['+33'],
    isExistingClient: boolToStrBool(!!previousContractId),
    previousContractNumber: previousContractId,
    carToBeReturned: !!offer?.carToRestitute,
    hasCoCustomer:
      ((customerData as any) /* TODO: Missing field. Waiting for BFT. */?.hasCoCustomer as boolean) ??
      missingMilesData?.hasCoCustomer,
  };
};

export type PrivateCustomerProspectForm = ReturnType<typeof getPrivateCustomerFormInitialValues>;

export const getPrivateCoCustomerFormInitialValues = (
  customerData: Partial<CustomerData>,
  milesCoCustomerRelationType: QuoteSchema.Schemas.MilesCoCustomerRelationType | undefined,
  missingMilesData?: MissingMilesData
) => {
  return {
    gender: customerData.gender,
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    birthName: customerData.birthName,
    dateOfBirth: apiDateToUiDate(customerData.dateOfBirth),
    profession: customerData.employment?.posFrOccupation ?? missingMilesData?.posFrOccupationCoCustomer,
    email: customerData.contactData?.emails?.[0]?.emailAddress?.toLowerCase(),
    telephonePhone: customerData.contactData?.telephoneNumber,
    mobilePhone: customerData.contactData?.mobilePhoneNumber,
    mobilePhoneCountryCode: customerData.contactData?.mobilePhoneCountryCode || TelephoneCountryCodesEnum['+33'],
    customerRelations:
      milesCoCustomerRelationType ??
      (missingMilesData?.milesCoCustomerRelationType as QuoteSchema.Schemas.MilesCoCustomerRelationType),
  };
};

export type PrivateCoCustomerProspectForm = ReturnType<typeof getPrivateCoCustomerFormInitialValues>;

export const getBusinessCustomerFormInitialValues = (
  quoteData: QuoteSchema.Schemas.QuoteResponse,
  customerData: Partial<CustomerData>,
  missingMilesData: MissingMilesData
) => {
  const offer = quoteData.financialProduct?.offers?.[0];
  const previousContractId = offer?.previousContractId;

  return {
    sirenWebserviceCall: customerData.companyData?.companyRegistrationNumber ?? missingMilesData.siren,
    legalEntity: customerData.companyData?.entityLegalForm ?? missingMilesData.legalEntity,
    companyName: customerData.companyData?.name,
    apecode: customerData.companyData?.apecode,
    companyCreationDate: apiDateToUiDate(customerData.companyData?.foundationDate),
    privateUserCheck:
      ((customerData.companyData as any) /* TODO: Missing field. Waiting for BFT. */
        ?.companyCarForPrivateUse as boolean) ?? false,
    mobilePhoneCountryCode: customerData.contactData?.mobilePhoneCountryCode || TelephoneCountryCodesEnum['+33'],
    mobilePhone: customerData.contactData?.mobilePhoneNumber,
    telephonePhone: customerData.contactData?.telephoneNumber,
    email: customerData.contactData?.emails?.[0]?.emailAddress?.toLowerCase(),
    isExistingClient: boolToStrBool(!!previousContractId),
    previousContractNumber: previousContractId,
    carToBeReturned: offer?.carToRestitute,
    gender: customerData.gender,
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    // birthName: customerData.birthName, // TODO: Missing field. Waiting for BFT.
    dateOfBirth: apiDateToUiDate(customerData.dateOfBirth),
  };
};

export type BusinessCustomerProspectForm = ReturnType<typeof getBusinessCustomerFormInitialValues>;

export type AnyCustomerProspectForm =
  | PrivateCustomerProspectForm
  | PrivateCoCustomerProspectForm
  | BusinessCustomerProspectForm;
